import { combineReducers, AnyAction, Reducer } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authUserSlice'
import appStateReducer from './slices/appStateSlice'
import customerReducer from './slices/customerSlice'
import creditUsageReducer from './slices/creditUsageSlice'
import employeeReducer from './slices/employeeSlice'
import employeeActivationReducer from './slices/employeeActivationSlice'
import employeeDeactivationReducer from './slices/employeeDeactivationSlice'
import shiftReducer from './slices/shiftSlice'
import payDeviationReducer from './slices/payDeviationSlice'
import integrationLogReducer from './slices/integrationLogSlice'
import payrollReducer from './slices/payrollSlice'
import dashboardMetricsReducer from './slices/dashboardMetricsSlice'
import payScheduleReducer from './slices/payScheduleSlice'
import fileReducer from './slices/fileSlice'
import payoutBasisReducer from './slices/payoutBasisSlice'
import agiAdjustmentReducer from './slices/agiAdjustmentSlice'
import foraAdjustmentReducer from './slices/foraAdjustmentSlice'
import bookkeepingConfigurationReducer from './slices/bookkeepingConfigurationSlice'
import employerInitiatedPayoutReducer from './slices/employerInitiatedPayoutSlice'
import customerPortalUserReducer from './slices/customerPortalUserSlice'
import customerPortalRolesReducer from './slices/customerPortalRolesSlice'
import companyGroupPortalUserReducer from './slices/companyGroupPortalUserSlice'
import companyGroupPortalRolesReducer from './slices/companyGroupPortalRolesSlice'
import companyGroupReducer from './slices/companyGroupSlice'
import openShiftReducer from './slices/openShiftSlice'

// Integrations
import fortnoxIntegrationReducer from './slices/integrations/fortnoxIntegrationSlice'
import plandayIntegrationReducer from './slices/integrations/plandayIntegrationSlice'
import tengellaIntegrationReducer from './slices/integrations/tengellaIntegrationSlice'

const appReducer = combineReducers({
    appState: appStateReducer,
    auth: authReducer,
    customer: customerReducer,
    paySchedule: payScheduleReducer,
    employee: employeeReducer,
    employeeActivation: employeeActivationReducer,
    employeeDeactivation: employeeDeactivationReducer,
    shift: shiftReducer,
    creditUsage: creditUsageReducer,
    payDeviations: payDeviationReducer,
    integrationLog: integrationLogReducer,
    payroll: payrollReducer,
    dashboardMetrics: dashboardMetricsReducer,
    files: fileReducer,
    payoutBasis: payoutBasisReducer,
    agiAdjustment: agiAdjustmentReducer,
    foraAdjustment: foraAdjustmentReducer,
    bookkeepingConfiguration: bookkeepingConfigurationReducer,
    employerInitiatedPayouts: employerInitiatedPayoutReducer,
    customerPortalUser: customerPortalUserReducer,
    customerPortalRoles: customerPortalRolesReducer,
    companyGroupPortalUser: companyGroupPortalUserReducer,
    companyGroupPortalRoles: companyGroupPortalRolesReducer,
    companyGroup: companyGroupReducer,
    openShifts: openShiftReducer,

    // integrations
    fortnoxIntegration: fortnoxIntegrationReducer,
    plandayIntegration: plandayIntegrationReducer,
    tengellaIntegration: tengellaIntegrationReducer
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
    if (action.type === 'authUser/logout') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
  };

export const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof appReducer>
export type AppDispatch = typeof store.dispatch
